import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import { NavLink } from "react-router-dom";

import { V2 } from "../../Api";
import { formatDateAge, formatDateLocalNumeric, formatName } from "../../Utilities";
import withContentStyle from "../withContentStyle";
import withTitle from "../withTitle";

import Indicator from "../Indicator";

import PatientOverviewInnerView from "./patient/PatientOverviewInnerView";
import PatientDocumentsInnerView from "./patient/PatientDocumentsInnerView";
import PatientSurgeryListView from "./patient/PatientSurgeryListView";

import "../../patient.css";
import HasRight from "../HasRight";


interface IPatientLandingViewProps extends RouteComponentProps<any> {

}

interface IPatientLandingViewState {
    isLoading: boolean | string;
    isFlagsLoading: boolean | string;
    patientInfo: any;
    flags: any[];
}

class PatientLandingView extends React.Component<IPatientLandingViewProps, IPatientLandingViewState> {
    constructor(props: Readonly<IPatientLandingViewProps>) {
        super(props);

        const state: IPatientLandingViewState = {
            isLoading: true,
            isFlagsLoading: true,
            patientInfo: {},
            flags: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
        this.loadFlags();
    }

    public render() {
        const pathBase = `/patient/${this.props.match.params.id}`;
        const info = this.state.patientInfo;

        if (this.state.isLoading === true) {
            return <div className="patient-page-body">
                <div className="spinner spinner-center lds-dual-ring-big" />
            </div>;
        }
        if (typeof this.state.isLoading === "string") {
            return <div className="patient-page-body">
                <div className="error-text">{this.state.isLoading}</div>
            </div>;
        }

        return (
            <div className="viewer-root viewer-full full-height-max">
                <div className="patient-details-header">
                    <div className="patient-details-header-content">
                        <div className="patient-details-primary">{formatName(info.name)}</div>
                        <div className="patient-details-subtext">{info.chartNumber} | {formatDateLocalNumeric(info.birthdate)} ({formatDateAge(info.birthdate)}y) | {info.sex}</div>
                        <div>
                            {typeof this.state.isFlagsLoading === "string"
                                ? <Indicator color="red" text="Could not load flags" icon="times" title={this.state.isFlagsLoading} />
                                : this.state.flags.map(a => <Indicator key={a.id} color={a.color} text={a.title} icon={a.icon} title={a.description} />)}
                        </div>
                    </div>
                    <div className="patient-details-tab-container">
                        <NavLink to={pathBase} exact={true} className="patient-details-tab" activeClassName="active" replace={true}>Overview</NavLink>
                        <HasRight right="document:read"><NavLink to={`${pathBase}/documents`} className="patient-details-tab" activeClassName="active" replace={true}>Documents</NavLink></HasRight>
                        <HasRight right="surgery:read"><NavLink to={`${pathBase}/surgeries`} className="patient-details-tab" activeClassName="active" replace={true}>Surgeries</NavLink></HasRight>
                    </div>
                </div>
                <Switch>
                    <Route path={`/patient/:id`} exact={true} component={PatientOverviewInnerView} />
                    <Route path={`/patient/:id/documents`} exact={true} component={PatientDocumentsInnerView}/>
                    <Route path={`/patient/:id/surgeries`} exact={true} component={PatientSurgeryListView}/>
                </Switch>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const patientInfo = await V2.get<any>(`patients/${this.props.match.params.id}/summary`);

            this.setState({
                isLoading: false,
                patientInfo: patientInfo
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load data"
            });
        }
    }

    private async loadFlags() {
        try {
            this.setState({
                isFlagsLoading: true
            });

            const result = await V2.get<any>(`patients/${this.props.match.params.id}/flags`);

            this.setState({
                isFlagsLoading: false,
                flags: result.flags
            });
        }
        catch (e) {
            this.setState({
                isFlagsLoading: e.message || "Could not load data"
            });
        }
    }
}

export default withTitle("Patient Details", withContentStyle("noborder", PatientLandingView));
